import Seo, { LOCAL_BUSINESS_LD } from '../components/Seo';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import Marquee from '../components/Marquee';
import TileGrid from '../components/sections/TileGrid';
import BeforeAfterGrid from '../components/sections/BeforeAfterGrid';
import Promise from '../components/sections/Promise';
import HowItWorks from '../components/sections/HowItWorks';
import Team from '../components/sections/Team';
import Compare from '../components/sections/Compare';
import Reviews from '../components/sections/Reviews';
import ThankYou from '../components/sections/ThankYou';
import Coverage from '../components/sections/Coverage';
import Partners from '../components/sections/Partners';
import Faq from '../components/sections/Faq';
import FinalCta from '../components/sections/FinalCta';
import { useT } from '../i18n/LangContext';
import { useContent } from '../data/useContent';
import { faqLd } from '../data/content';

export default function HomePage() {
  const t = useT();
  const { SERVICES, HOME_FAQS } = useContent();

  const SERVICE_LD = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: SERVICES.map((s, i) => ({
      '@type': 'Service',
      position: i + 1,
      name: s.name,
      provider: { '@type': 'Painter', name: 'Reverence Services', telephone: '+1-613-859-5893' },
      areaServed: 'Ottawa, ON',
      url: `${process.env.REACT_APP_BACKEND_URL}/${s.slug}`,
    })),
  };

  return (
    <>
      <Seo
        title={t['seo.home.title']}
        description={t['seo.home.desc']}
        jsonLd={[LOCAL_BUSINESS_LD, SERVICE_LD, faqLd(HOME_FAQS)]}
      />
      <Hero />
      <Services />
      <Marquee items={SERVICES.map((s) => s.name)} />
      <TileGrid />
      <BeforeAfterGrid />
      <Promise />
      <HowItWorks />
      <Team />
      <Compare />
      <Reviews />
      <ThankYou />
      <Coverage />
      <Partners />
      <Faq />
      <FinalCta />
    </>
  );
}
